import type { Handler } from './handler';
import type {
  ApiRegisterUserJourneyEventParams,
  ApiRegisterUserJourneyEventPort,
} from './ports/api-register-user-journey-event.port';
import { resolveAdapter } from '~/adapters/registry';

export enum UserJourneyEvent {
  ENTER_SITE = 'enter_site',
  REGISTER_USER = 'register_user',
  MAKE_DEPOSIT = 'make_deposit',
  WITHDRAW = 'withdraw',
  SUBMIT_KYC = 'submit_kyc',
  BLOG_POST_CLICK = 'blog_post_click',
  APP_INSTALL = 'app_install',
  HOME_MENU_ITEM_CLICK = 'home_menu_item_click',
}

type Params = ApiRegisterUserJourneyEventParams;

type Ports = { apiRegisterUserJourneyEvent: ApiRegisterUserJourneyEventPort };

type Result = Promise<void>;

export const registerUserJourneyEventHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiRegisterUserJourneyEvent: resolveAdapter('apiRegisterUserJourneyEvent'),
  },
) => {
  await ports.apiRegisterUserJourneyEvent.handle(params);
};
